
import { Component, Prop, Mixins, Watch, Vue } from 'vue-property-decorator';
import QRCode from 'qrcode';
import ModelMixin from '@/mixins/ModelMixin';
import LoadableMixin from '@/mixins/LoadableMixin';
import api from '@/modules/api';
import { mutations } from '@/store/types';
import _get from 'lodash.get';
import { getErrorMessage } from '@/utils/common';

@Component({
    components: {},
    mixins: [ModelMixin],
})
export default class TwoFactorAuthPopup extends Mixins<LoadableMixin, ModelMixin<boolean>>(LoadableMixin, ModelMixin) {
    qrCode = '';
    twoFactorToken = '';
    result = false;

    @Prop({ required: true })
    onClose!: (result: boolean) => void;

    @Prop({ required: true })
    enabled!: boolean;

    @Watch('model', { immediate: true })
    onModelChange(newValue: boolean, oldValue: boolean) {
        if (newValue && !oldValue) {
            this.qrCode = '';
            this.twoFactorToken = '';
            this.result = false;
        }
    }

    async enable2fa() {
        const { twoFactorToken } = await api.twoFactorAuthInit();
        this.qrCode = await QRCode.toDataURL(twoFactorToken);
    }

    async check2fa() {
        if (!this.twoFactorToken) return Vue.toasted.error(`Please enter authentication code`);
        this.$store.commit(mutations.LOADING, { loading: true });
        try {
            const { success } = await api.twoFactorAuthVerify({ token: this.twoFactorToken });
            if (success) {
                const { userDetails } = await api.loadUser();
                this.$store.commit(mutations.SET_USER, { user: userDetails });
                this.result = true;
                // dlg.success(
                //     'Two-factor authentication was enable for your account. On next login please use your authentication device.',
                //     '',
                // );
            } else {
                Vue.toasted.error(`Invalid verification token`);
                this.result = false;
            }
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
            this.result = false;
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }

    close() {
        this.onClose && this.onClose(this.result);
        this.model = false;
        this.result = false;
    }
}
